import { en_US } from '@docupet/component-library';

export default {
  ...en_US,
  cancelRegistration: 'Cancel Registration',
  back: 'Back',
  accessCode: 'Activation Code',
  address: 'Address',
  callus: 'Call Us',
  city: 'City',
  civic: 'Number',
  continue: 'Continue',
  postalCode: 'Zip Code',
  province: 'State',
  later: "I'll do this later",
  tagNumber: 'Tag Number',
  petName: 'Pet Name',
  phoneNumber: 'Phone Number',
  mobilePhone: 'Mobile',
  homePhone: 'Home',
  workPhone: 'Work',
  login: 'Log In',
  signUp: 'Sign Up',
  street: 'Street',
  submit: 'Submit',
  email: 'Email address',
  password: 'Create password',
  firstName: 'First Name',
  lastName: 'Last Name',
  male: 'Male',
  female: 'Female',
  iAgree: 'I Agree',
  unit: 'Unit/Apt/Suite',
  welcome: "Let's get your address",
  phonePlaceholder: '(___) ___-____',
  yes: 'Yes',
  no: 'No',
  dog: 'Dog',
  cat: 'Cat',
  optional: 'Optional',
  requiredField: ' (required)',
  optionalField: ' (optional)',
  success: 'Success',
  now: 'now',
  selectLocation: 'Select a state',
  colors: {
    white: 'White',
    lightGrey: 'Light-grey',
    darkGrey: 'Dark-grey',
    black: 'Black',
    orange: 'Orange',
    red: 'Red',
    cream: 'Cream',
    apricot: 'Apricot',
    golden: 'Golden',
    tan: 'Tan',
    brown: 'Brown',
    darkBrown: 'Dark-brown',
  },
  validations: {
    messages: {
      _default: 'invalid',
      required: 'required',
    },
  },
  footer: {
    copyright: 'DocuPet Inc. All rights reserved.',
    links: {
      about: 'About DocuPet',
      tos: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
  },
  registerBanner: {
    previouslyRegisteredPet: 'Have you previously licensed a pet?',
    havePreviouslyRegisteredPet: 'If you have previously licensed your pet, we likely have your record on file.',
    fetchMyRecord: 'Look up my record',
  },
  registerPanel: {
    join: 'Create your secure licensing account',
    joinInfo: `From this new account you can manage your profile, access licensing records, and use our free Home<em>Safe</em><sup>&reg;</sup> Lost Pet Service.`,
    createNewOnlineAccount: 'Create a New Online Account',
    createNewAccountInfo: `Create a free online account and then add any pets you own. You'll gain free access to our Home<em>Safe</em><sup>&reg;</sup> Lost Pet Service with every tag.`,
    benefits: {
      title: 'Benefits of your DocuPet account',
      items: {
        homeSafeService: `Protect your pet and enjoy peace of mind with linked profiles and the Home<em>Safe</em><sup>&reg;</sup> lost pet service`,
        designerTags: `Browse our full collection of designer tag styles, add personalization or design your own!`,
        dashboard: `A central dashboard for all of your pet's important information`,
        changeAccount: `Manage, or make changes to your account at anytime including updating your contact information and making changes to pet details and status`,
      },
    },
    agreeToTCTooltip:
      "In order to complete your online registration, you must agree to DocuPet's Terms of Service and Privacy Policy. If you do not wish to proceed you may visit the Licensing page for alternate ways to complete the licensing process offline. Our Terms of Service and Privacy Policy outline our customers' use of DocuPet services. Please read these terms carefully before accepting.",
    title: 'Enter your name',
    title2: 'and create a password',
    alreadyHaveAccount: 'Already have an account?',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    emailPlaceholder: 'Enter email address',
    passwordPlaceholder: 'Create password',
    overThePhone: 'Over the phone',
    backToOnlineRegistration: 'Back to Online Registration',
    personOrMail: 'In person or by mail',
    otherWaysToRegister: 'Other ways to register:',
  },
  noticeOfCollectionPanel: {
    info: 'I understand that my personal information, as defined by the Municipal Freedom of Information and Protection of Privacy Act (MFIPPA), including (but not limited to) my name, address, and contact information, is collected and will be used in accordance with MFIPPA, the Personal Information Protection and Electronic Documents Act (PIPEDA), and all other relevant privacy legislation.',
    bulletsInfo: 'I understand that the personal information I have provided:',
    bullet1: 'is collected through a website hosted by DocuPet on behalf of the Corporation of the City of Kingston (the "City");',
    bullet2:
      'will be used by City staff for the registration of my pet in accordance with By-Law 2004-144, being a By-Law to Regulate Animals; and',
    bullet3:
      'may also be used by third parties, partnered with the City, for licensing purposes such as registering pets and enforcing the By-Law to Regulate Animals.',
  },
  overThePhone: {
    title: 'Over the Phone',
    infoHeading: 'Give us a call',
    info2:
      'Please note we are only able to accept credit card (Mastercard, VISA, VISA Debit, American Express, or Discover) payments over the phone.',
  },
  personOrMail: {
    title: 'In Person or by Mail',
  },
  termsOfService: {
    title: 'Terms of Service',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
  },
  welcomePanel: {
    whereLiveWithPet: 'Where do you live?',
    civicPlaceholder: '',
    streetPlaceholder: '',
    unitPlaceholder: '',
    cityPlaceholder: '',
    postalCodePlaceholder: '',
    mailingAddressSame: 'My mailing address is the same as my home address. (This is where we will send your tags.)',
    mailingAddress: 'Mailing Address',
    additional: 'Additional (e.g. P.O. Box or G.D. Station)',
    additionalPlaceholder: '',
    phoneNumberText: 'We will use this to contact you if your pet is lost.',
  },
  provinces: {
    alberta: 'Alberta',
    britishColumbia: 'British Columbia',
    manitoba: 'Manitoba',
    ontario: 'Ontario',
    quebec: 'Quebec',
    newfoundlandLabrador: 'Newfoundland and Labrador',
    newBrunswick: 'New Brunswick',
    novaScotia: 'Nova Scotia',
    princeEdwardIsland: 'Prince Edward Island',
    saskatchewan: 'Saskatchewan',
    northwestTerritories: 'Northwest Territories',
    nunavut: 'Nunavut',
    yukon: 'Yukon',
  },
  petPanel: {
    aboutYourPet: 'Tell us about your pet',
    petPanelInfo:
      'Information about your pet is required to complete your registration. These basic details will be helpful in identifying your pet should they become lost or found. This information is not shared publicly unless you provide consent within your profile settings.',
    dontHaveAPet: "Don't have a pet?",
    dontWantToAddPet: "I don't wish to add a pet.",
    doneAddingPet: 'Done adding pets?',
    skipThisStep: 'Skip this step',
    whatKindOfPet: 'What kind of pet do you have?',
    chooseOne: 'Choose one',
    petsName: "What is your pet's name?",
    petNameEditWarning: "Update your pet’s name if the spelling is incorrect or if you are changing the name of your pet. Don’t use this record for another pet as all of your pet’s information needs to match the details that are on official documents that may need to be provided for licensing.",
    whatBreed: 'What breed are they?',
    whatSex: 'What sex are they?',
    knowBirthDate: 'Do you know their date of birth?',
    approximateAge: 'Approximate Age:',
    whatColor: 'What color are they?',
    selectAll: 'Select all that apply',
    indoorCat: 'Indoor Cat',
    outdoorCat: 'Outdoor Cat',
    namePlaceholder: 'Enter a name',
    breedPlaceholder: 'Enter breed',
    noMorePets: 'No more pets to add?',
    birthdate: 'Birthdate',
    dateOptions: {
      jan: 'Jan',
      feb: 'Feb',
      mar: 'Mar',
      apr: 'Apr',
      may: 'May',
      jun: 'Jun',
      jul: 'Jul',
      aug: 'Aug',
      sept: 'Sept',
      oct: 'Oct',
      nov: 'Nov',
      dec: 'Dec',
    },
    petCatOptionsRequired: 'Please let us know if {catName} is an indoor cat or an outdoor cat.',
    petSpeciesRequired: "Please select your pet's species",
    petNameRequired: "Please enter your pet's name",
    petBreedRequired: "Please enter your pet's breed",
    petSexRequired: "Please select your pet's sex",
    petAgeRequired: "Please provide your pet's age",
    petApproximateBirthdateRequired: "Please approximate your pet's age",
    petColorRequired: 'Please pick at least one color',
    petWithNameExists: 'A pet with that name already exists',
  },
  medPanel: {
    is: 'Is ',
    does: 'Does ',
    isFixed: ' spayed or neutered?',
    isMicrochipped: ' microchipped?',
    whatVet: ' have a Veterinarian?',
    rabiesExpiryBefore: '',
    rabiesExpiryAfter: "'s rabies vaccination expiry date",
    verifyLabel1: 'I verify that ',
    verifyLabel2: "'s information contained within this form is correct, and ",
    verifyLabel3: "'s vaccines are up to date.",
    microchipNumber: 'Microchip Number',
  },
  addProceedPanel: {
    title: 'Thank you!',
    title2: "That's all we need for",
    addAnotherPet: 'Add Another Pet',
  },
  addImage: {
    title: 'Add a photo for',
    info: 'Uploading a photo of your pet to their profile will help in quickly identifying them should they become lost',
    addPhoto: 'Add Photo',
    changePhoto: 'Change Photo',
    bullets: {
      recentPhoto: 'Ensure photos are recent and legible',
      multiplePhotos: 'Upload multiple photos from inside your account to showcase any markings or characteristics unique to your pet',
      directlyFromDevice: 'Snap a photo directly from your device camera, or upload from gallery',
      notSharedPublicly: 'Photos are not shared publicly unless you provide consent within your profile settings',
    },
  },
  ownerPanel: {
    title: 'About you',
    contactInfoRequired: `Contact information is required to complete your registration. Your physical address and phone number are needed to ship your order and also serves as crucial information for our Home<em>Safe</em><sup>&reg;</sup> team to rely on in the event of your pet becoming lost or found.`,
    whereDoYouLive: 'Where do you live?',
    howToPopulateAddress:
      "To begin populating your address, type your house number followed by your street name (all street types are abbreviated, for example “street” becomes “st.”). If your address isn't automatically populating, check that all spelling and information is correct and only if you must, enter it manually in the fields below.",
    info: "If someone finds your pet, this is how we'll know where their home is! It's also where we will ship your tags.",
    tellUsAboutYou: 'We will need your phone number',
    whatIsYourPhoneNumber: 'What is your phone number?',
    primaryPhone: 'Primary Phone',
    secondaryPhone: 'Secondary Phone',
    birthdate: '...and your date of birth',
  },
  paperwork: {
    documentsFor: 'Documents for ',
    pleaseAddRabies: 'Please add rabies vaccination certificate',
    pleaseAddSpayNeuter: 'Please add spay/neuter certificate',
    whatHappensAfter: 'What happens after I complete the licensing process?',
    existingCopy: 'Documentation uploaded via the online system is reviewed within two business days.',
  },
  licenseSummary: {
    title: 'We are the official pet licensing partner of ',
    oops: 'Oops!',
    problemLoadingLicenses1:
      "We couldn't find any licenses to apply to one or more of your pets. Please contact customer service by calling ",
    problemLoadingLicenses2: ' between 9am - 8pm EST, or by emailing us at info@docupet.com',
  },
  input: {
    addressValidationError: 'Address is invalid, please check fields above and try again.',
    mailingAddress: {
      label: "What's your mailing address?",
    },
    streetAddress: {
      label: 'Street Address',
    },
    postalCode: {
      label: 'Zip Code',
      placeholder: 'Enter Zip code',
    },
    province: {
      label: 'State',
    },
    city: {
      label: 'City',
      placeholder: 'Enter city name',
    },
    unit: {
      label: 'Unit/Apt/Suite',
      placeholder: '',
    },
    street: {
      label: 'Street',
      placeholder: 'Enter street name',
    },
    civic: {
      label: 'Number',
      placeholder: '',
    },
    phoneNumber: {
      placeholder: 'Enter phone number',
      remove: 'Remove',
      addAnotherNumber: 'Add another number',
      primaryPhone: {
        label: "What's your primary phone number?",
      },
      secondaryPhone: {
        add: 'Add your secondary phone numbers',
      },
      customErrorMessage: {
        hasValue: 'Please enter your ten digit phone number',
        isEmpty: 'Please enter your phone number',
      },
    },
  },
  meta: {
    title: {
      BaseURL: 'Join DocuPet',
      ContactDetails: 'About you',
      AboutYourPet: 'Tell us about your pet',
      AddAnotherPet: 'Thank you!',
      AddPetImage: 'Add a photo',
      FindLicensingCommunity: 'Find Your License Community',
    },
  },
  errorMessages: {
    error: 'ERROR',
    duplicatePetCancelRegistration:
      'If you wish to use the email provided for your existing record please cancel this registration now. Note that if you proceed with canceling this registration record you started will be permanently deleted.',
    poBoxOnly:
      'We require a physical address for your profile in the event that your pet becomes lost and needs to be returned to you. You may add an additional mailing address by unchecking the box below.',
    genericError: 'An error occurred while registering, please try again!',
    termsOfServiceRequired: 'Please read and agree to the Terms of Service to proceed',
    defaultRequired: 'The {field} is required',
    invalidCharacters: 'The {field} has invalid characters',
  },
  provincesAbbr: {
    US_AL: `Alabama`,
    US_AK: `Alaska`,
    US_AZ: 'Arizona',
    US_AR: `Arkansas`,
    US_CA: `California`,
    US_CO: `Colorado`,
    US_CT: `Connecticut`,
    US_DE: `Delaware`,
    US_FL: `Florida`,
    US_GA: `Georgia`,
    US_HI: `Hawaii`,
    US_ID: `Idaho`,
    US_IL: `Illinois`,
    US_IN: `Indiana`,
    US_IA: `Iowa`,
    US_KS: `Kansas`,
    US_KY: `Kentucky`,
    US_LA: `Louisiana`,
    US_ME: `Maine`,
    US_MD: `Maryland`,
    US_MA: `Massachusetts`,
    US_MI: `Michigan`,
    US_MN: `Minnesota`,
    US_MS: `Mississippi`,
    US_MO: `Missouri`,
    US_MT: `Montana`,
    US_NE: `Nebraska`,
    US_NV: `Nevada`,
    US_NH: `New Hampshire`,
    US_NJ: `New Jersey`,
    US_NM: `New Mexico`,
    US_NY: `New York`,
    US_NC: `North Carolina`,
    US_ND: `North Dakota`,
    US_OH: `Ohio`,
    US_OK: `Oklahoma`,
    US_OR: `Oregon`,
    US_PA: `Pennsylvania`,
    US_RI: `Rhode Island`,
    US_SC: `South Carolina`,
    US_SD: `South Dakota`,
    US_TN: `Tennessee`,
    US_TX: `Texas`,
    US_UT: `Utah`,
    US_VT: `Vermont`,
    US_VA: `Virginia`,
    US_WA: `Washington`,
    US_WV: `West Virginia`,
    US_WI: `Wisconsin`,
    US_WY: `Wyoming`,
  },
  licensingCommunity: {
    title: '@:meta.title.FindLicensingCommunity',
    leading: 'We provide pet licensing services to over 230 jurisdictions across {provinceCount} states. We add a new community partner every few days!',
    subtitle: 'Select your state below to see a list of DocuPet licensing communities.',
    selectLocation: 'Select a state',
    notSeeing: 'Not seeing your community, that’s OK!',
    shop: "We are nationwide, <a href={url} class='text-decoration-underline'>register for free now</a> and you’ll be informed if you can purchase your pet license from within your DocuPet profile in the future.",
    communityCount:
      'DocuPet provides licensing services in the community below. Click the name of your community to go to your local licensing site.| DocuPet provides licensing services in the {count} communities below. Click the name of your community to go to your local licensing site.',
  },
};
